import { Injectable, signal } from '@angular/core';
import { RequestLog } from './request-log';

@Injectable({providedIn: 'root'})
export class RequestLogService {
  private _requests = signal<RequestLog[]>([])
  requests = this._requests.asReadonly();

  add(item: RequestLog): void {
    this._requests.set([...this._requests(), item]);
  }
}
